import { render, staticRenderFns } from "./GiftCertificateSales.vue?vue&type=template&id=7ba9f773"
import script from "./GiftCertificateSales.vue?vue&type=script&lang=ts"
export * from "./GiftCertificateSales.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports